import Vue from 'vue'
import vueRouter from 'vue-router'
import home from './views/home/home.vue'
import ErrorPage404 from './components/404'
const login = r => require.ensure([], () => r(require('./views/login/login.vue')), 'login')
Vue.use(vueRouter)

export const routes = [

   {
    path: '/', // 默认进入路由[写在第一个]
    redirect: '/home' // 重定向
    },
   {
    path: '/login',
    name:'login',
    component: login
  },
    {
      path: '/404',
      name: 'notFound',
      component: ErrorPage404
    }
  ]


const routerModel = (process.env.NODE_ENV === 'development') ? 'hash' : 'history';
export const createRouter = () => new vueRouter({
  mode: routerModel,
  routes: routes,
})
export default new vueRouter({
  mode: routerModel,
  routes: routes
});


// WEBPACK FOOTER //
// ./src/routes.js